var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationNotChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 4.8125C12.675 4.8125 12.1875 4.6125 11.7875 4.2125C11.3875 3.8125 11.1875 3.325 11.1875 2.75C11.1875 2.175 11.3875 1.6875 11.7875 1.2875C12.1875 0.8875 12.675 0.6875 13.25 0.6875C13.825 0.6875 14.3125 0.8875 14.7125 1.2875C15.1125 1.6875 15.3125 2.175 15.3125 2.75C15.3125 3.325 15.1125 3.8125 14.7125 4.2125C14.3125 4.6125 13.825 4.8125 13.25 4.8125ZM1.625 14C1.325 14 1.0625 13.8875 0.8375 13.6625C0.6125 13.4375 0.5 13.175 0.5 12.875V3.125C0.5 2.825 0.6125 2.5625 0.8375 2.3375C1.0625 2.1125 1.325 2 1.625 2H9.7625C9.725 2.1875 9.7 2.375 9.6875 2.5625C9.675 2.75 9.68125 2.9375 9.70625 3.125C9.75625 3.5625 9.87812 3.97187 10.0719 4.35312C10.2656 4.73438 10.5187 5.06875 10.8312 5.35625L8 7.2125L1.625 3.06875V4.15625L8 8.3375L11.6562 5.9375C11.9062 6.0625 12.1625 6.15625 12.425 6.21875C12.6875 6.28125 12.9625 6.3125 13.25 6.3125C13.6625 6.3125 14.0594 6.24375 14.4406 6.10625C14.8219 5.96875 15.175 5.76875 15.5 5.50625V12.875C15.5 13.175 15.3875 13.4375 15.1625 13.6625C14.9375 13.8875 14.675 14 14.375 14H1.625Z",
    fill: "#CDCDCD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationNotChecked);
export default __webpack_public_path__ + "static/media/notificationNotChecked.84ecab4731bc6640e591c993a03f93a3.svg";
export { ForwardRef as ReactComponent };